export default __webpack_public_path__ + "85fe79248de2541b6360ddaed5f340d4.png";